import { Guid } from '@web/utils';
import { BrandSocialMediaCode } from '../enums/brand-social-media-code';

export class BrandSocialMedia {
  public constructor(
    public readonly id: Guid,
    public readonly code: BrandSocialMediaCode,
    public readonly url: string,
  ) {}
}
